import { Vue, Component, Prop } from 'vue-property-decorator'
import SampleDetailedIcon from '@/assets/images/svg/sample-detailed-icon.vue'
import CommonSampleStatusBadge from '@/components/common/CommonSampleStatusBadge.vue'

@Component({
    components: {
        SampleDetailedIcon,
        CommonSampleStatusBadge
    }
})
export default class GrossingTouchSampleNavigationCard extends Vue {
    @Prop(Object) readonly sampleInfo!: object
}
